declare global {
  interface Window {
    Razorpay?: new (options: RazorpayOptions) => { open: () => void };
  }
}

interface RazorpayOptions {
  key: string;
  amount: number;
  currency: string;
  name: string;
  description: string;
  order_id: string;
  handler: (response: {
    razorpay_payment_id: string;
    razorpay_order_id: string;
    razorpay_signature: string;
  }) => void;
  prefill?: { email?: string };
  theme?: { color: string };
  modal?: { ondismiss?: () => void };
}

let scriptPromise: Promise<void> | null = null;

export function loadRazorpayScript(): Promise<void> {
  if (window.Razorpay) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Razorpay'));
    document.body.appendChild(script);
  });
  return scriptPromise;
}

export function openRazorpayCheckout(options: {
  keyId: string;
  orderId: string;
  amountPaise: number;
  currency: string;
  planName: string;
  email?: string;
  onSuccess: (payment: {
    razorpayPaymentId: string;
    razorpayOrderId: string;
    razorpaySignature: string;
  }) => void;
  onDismiss?: () => void;
}): void {
  if (!window.Razorpay) {
    throw new Error('Razorpay not loaded');
  }
  const rzp = new window.Razorpay({
    key: options.keyId,
    amount: options.amountPaise,
    currency: options.currency,
    name: 'Fattah POS',
    description: options.planName,
    order_id: options.orderId,
    handler: (res) => {
      options.onSuccess({
        razorpayPaymentId: res.razorpay_payment_id,
        razorpayOrderId: res.razorpay_order_id,
        razorpaySignature: res.razorpay_signature,
      });
    },
    prefill: options.email ? { email: options.email } : undefined,
    theme: { color: '#2563eb' },
    modal: { ondismiss: options.onDismiss },
  });
  rzp.open();
}
